import React, { useEffect } from 'react'
import { saveSettingState } from '../../../utils/fns'
import { appConfig, initialState } from '../common/constants'
import { fetchStaticData } from '../store/staticDataAction'
import { store } from '../store/store'
import queryString from 'query-string'
import PageView from '../containers/PageView'

//TODO use json file
// import staticData from './common/staticData.json'

function App() {
  saveSettingState(appConfig, initialState.settings)

  // Check URL query string for initial states (RDLC integration)
  const search = window.location.search
  const params = search ? queryString.parse(window.location.search) : {}

  //TODO use json file
  // const [ myInitial, errors ] = initCalculationCall(params, staticData)
  // store.dispatch(setInitialState(myInitial))
  // if (myInitial.subApp === '0') {
  //   store.dispatch(dowelingCalculation(myInitial, staticData))
  // } else {
  //   store.dispatch(crackInjectionCalculation(myInitial, staticData))
  // }
  // store.dispatch(fetchStaticDataSuccess(staticData))

  //TODO use API call
  store.dispatch(fetchStaticData(params))

  useEffect(() => {
    if (params && params.source && params.source === 'EC') {
      document.documentElement.classList.add('-customerPortal')
    } else {
      document.documentElement.classList.remove('-customerPortal')
    }
  }, [])

  return <PageView />
}

export default App
